var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2003 3.10896L10.707 11.4399C10.6059 11.5388 10.4967 11.6086 10.3796 11.6493C10.2625 11.6899 10.1373 11.7092 10.004 11.7071C9.87063 11.7056 9.74587 11.6832 9.62968 11.6399C9.51349 11.5966 9.40595 11.5247 9.30706 11.4243L0.976411 2.90598C0.745691 2.67007 0.63228 2.37712 0.636178 2.02714C0.640076 1.67716 0.768409 1.37857 1.02118 1.13137C1.27395 0.884172 1.56699 0.762428 1.9003 0.766141C2.23361 0.769853 2.52387 0.898094 2.77107 1.15086L10.0388 8.58226L17.4702 1.31458C17.7061 1.08386 17.995 0.9704 18.337 0.974209C18.679 0.978018 18.9732 1.1063 19.2198 1.35906C19.467 1.61183 19.5887 1.90487 19.585 2.23819C19.5813 2.5715 19.4531 2.86176 19.2003 3.10896Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1b6ac9299e756327279a63bb00fc8fc4.svg";
export { ForwardRef as ReactComponent };